module.exports = __webpack_public_path__ + "img/xcx-code.8f20cb7e.jpg";